import { render, staticRenderFns } from "./distribute.vue?vue&type=template&id=02af978f&scoped=true"
import script from "./distribute.vue?vue&type=script&lang=js"
export * from "./distribute.vue?vue&type=script&lang=js"
import style0 from "./distribute.vue?vue&type=style&index=0&id=02af978f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02af978f",
  null
  
)

export default component.exports